<!-- Demo Purposes Only -->
<!-- C3-2 (04 §3.5): the Material floating-action-button trigger that used to live here was
     dead — <app-options> is never rendered (admin-layout.component.html has
     it permanently commented out) — deleted rather than migrated. The rest
     of this dead-but-declared component is still migrated to vng for
     consistency / zero remaining Material hits. -->
<vng-card variant="outline" class="settings-panel pa-0" *ngIf="showSettings">
  <div
    class="options-toolbar"
    style="
      display: flex;
      align-items: center;
      justify-content: space-between;
      background: var(--warn);
      color: #fff;
      padding: 0 16px;
      min-height: 56px;
    "
  >
    <span style="flex:1 1 0%">Options</span>
    <button vng-button variant="ghost" size="sm" (click)="showSettings = false">
      <vng-icon name="close" [outline]="false" color="inherit"></vng-icon>
    </button>
  </div>
  <div class="demo-checkbox pa-1">
    <div class="pb-1">
      <vng-checkbox [(ngModel)]="options.collapsed" (change)="sendOptions()" [labelPosition]="end"
        >Collapsed Sidebar</vng-checkbox
      >
    </div>
    <div class="pb-1">
      <vng-checkbox [(ngModel)]="options.boxed" (change)="sendOptions()" [labelPosition]="end"
        >Boxed Layout</vng-checkbox
      >
    </div>
    <div class="pb-1">
      <vng-checkbox [(ngModel)]="options.dark" (change)="sendOptions()" [labelPosition]="end">Dark Mode</vng-checkbox>
    </div>
    <div class="pb-1">
      <vng-checkbox (change)="options.dir = options.dir == 'rtl' ? 'ltr' : 'rtl'; sendOptions()" [labelPosition]="end"
        >RTL</vng-checkbox
      >
    </div>
  </div>
</vng-card>
<!-- /Demo Purposes Only -->
